import { SolitaireGame } from 'game/SolitaireGame';

export function isMagicNeeded(game: SolitaireGame) {
    if (game.cards.find((c) => !c?.visible)) return true;
    if (game.columns.find((c) => c.getNextMovingGroup().length)) return true;
    if (game.wastePile && game.wastePile.length > 1) return true;

    return false;
}
